import PrimeInvestmentPreferenceContainer from "./PrimeInvestmentPreferenceContainer";
import PrimeInvestmentPreferenceStore from "./PrimeInvestmentPreferenceStore";

export default PrimeInvestmentPreferenceStore(PrimeInvestmentPreferenceContainer);
